export const BILLING_ENABLED = false
export const EVV_ENABLED = false
export const CLOCK_IN_OUT_ENABLED = false

export const FEATURE_FLAGS = {
  billing: BILLING_ENABLED,
  evv: EVV_ENABLED,
  clockInOut: CLOCK_IN_OUT_ENABLED,
} as const

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS

export const FEATURE_FLAG_LABELS: Record<FeatureFlagKey, string> = {
  billing: 'Billing',
  evv: 'EVV',
  clockInOut: 'Clock In / Out',
}

export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  return FEATURE_FLAGS[flag]
}
